import React from 'react'
// import { Image } from 'react-native'

const AntiClippyL = () => (
   //<Image source = {require('./assets/antiClippyL.png')} />
   <img src={require('./assets/antiClippyL.png')} alt='anitclip' />
)
export default AntiClippyL